import React from 'react';

const SvgSi = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SI_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="SI_svg__d" d="M0 13.333h28V20H0z" />
      <filter
        x="-5.4%"
        y="-22.5%"
        width="110.7%"
        height="145%"
        filterUnits="objectBoundingBox"
        id="SI_svg__c"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SI_svg__b" fill="#fff">
        <use xlinkHref="#SI_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M0 6.667h5.333V5.333s1.03-.666 2-.666 1.911.666 1.911.666v1.334H28v6.666H0V6.667zm7.333 2.666a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666z"
        fill="#0C47B7"
        mask="url(#SI_svg__b)"
      />
      <g mask="url(#SI_svg__b)">
        <use fill="#000" filter="url(#SI_svg__c)" xlinkHref="#SI_svg__d" />
        <use fill="#E53B35" xlinkHref="#SI_svg__d" />
      </g>
    </g>
  </svg>
);

export default SvgSi;
